import { render, staticRenderFns } from "./glassBlockAddDialog.vue?vue&type=template&id=139295a0&"
import script from "./glassBlockAddDialog.vue?vue&type=script&lang=js&"
export * from "./glassBlockAddDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports